import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@/components/Text";
import { Checkbox, Flex } from "@/eworkitComponents";
import { IFilterComponentProps, useOnChangeFilterHandler } from "@/infrastructure/Filter";

interface IUnassignedTasksFilterProps extends IFilterComponentProps {}

export const UnassignedTasksFilter: FC<IUnassignedTasksFilterProps> = ({ name, value, onChange }) => {
  const { t } = useTranslation("session");
  const handleFilterChange = useOnChangeFilterHandler(name, onChange);

  const handleChange = useCallback(
    (newValue: boolean) => {
      handleFilterChange(newValue ? false : undefined);
    },
    [handleFilterChange],
  );

  return (
    <Flex direction="column" width={6}>
      <Checkbox checked={value} onChange={handleChange}>
        <Text size="md" color="black">
          {t("TASKS.FILTERS.UNASSIGNED_TASKS_LABEL")}
        </Text>
      </Checkbox>
    </Flex>
  );
};
